import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import matchingPairsCtActions from 'redux/actions/matching_pairs_ct_actions'
import pickerSelector from 'redux/selectors/picker/picker_selector'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import FilePickerModal from 'views/modals/file_picker_modal'

class ReferenceMediaFilePicker extends PureComponent {

	constructor(props) {
		super(props)
		this.onFilePicked = this.onFilePicked.bind(this)
		this.onFileError = this.onFileError.bind(this)
	}

	onFilePicked(files, acceptedFiles) {
		this.props.actions.filePicked(acceptedFiles, files, this.props.cardName, false)
	}

	onFileError(error) {
		this.props.actions.fileError(error, this.props.cardName, this.props.clientId)
	}

	render() {
		return (
			<FilePickerModal
				accept={['image']}
				multiselect={false}
				onFilesPicked={this.onFilePicked}
				onFileError={this.onFileError}
				closeHandler={this.props.actions.closeModal}
				pickerType={this.props.pickerType}
				googleDrivePickerOrigin={this.props.googleDrivePickerOrigin}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: matchingPairsCtActions.pairImagePickerClose,
		filePicked: matchingPairsCtActions.pairImagePicked,
		fileError: matchingPairsCtActions.pairImagePickError,
	}, dispatch)
}

function mapStateToProps(state) {
	return pickerSelector(state)
}

export default connect(mapStateToProps, mapDispatchToProps)(ReferenceMediaFilePicker)
